

















































































import {
  Component,
  mixins,
  namespace,
  Prop,
  Watch,
  Vue,
} from 'nuxt-property-decorator'
import '~/assets/scss/v-tooltip.scss'
import VueScrollTo from 'vue-scrollto'
import { filterUrl } from '~/assets/filters/url'
import { PRODUCTS_API } from '~/assets/config/api-path'
import { IProductAvailabilityStoresItem } from '~/assets/interfaces/products'
import { filterPhone } from '~/assets/filters/phone'
import MixinGeneral from '~/assets/mixins/general'
import { Map, ObjectManager, Placemark } from '~/assets/shims/ymaps'
import { analyticsReachGoal } from '~/assets/functions/analytics'
import ComponentFormButton from '~/components/form/button.vue'
import ComponentHiddenPhone from '~/components/products/hidden-phone.vue'
import ComponentLoadingDots from '~/components/loading/dots.vue'
import ComponentCatalogLabels from '~/components/catalog/labels/labels.vue'

const siteStore = namespace('site')

Vue.use(VueScrollTo)

@Component({
  components: {
    ComponentLoadingDots,
    ComponentCatalogLabels,
    ComponentHiddenPhone,
    ComponentFormButton,
  },
  filters: {
    filterPhone,
  },
})
export default class ComponentProductAvailabilityStoresMap extends mixins(
  MixinGeneral
) {
  @Prop({ type: Number, default: -1 }) readonly productId!: number
  @Prop({ type: String, default: 'шт' }) readonly unit!: string

  @siteStore.Getter('getApiKeyYandexMap') private getApiKeyYandexMap!:
    | string
    | null

  private title = ''
  private items: IProductAvailabilityStoresItem[] = []
  private isShowQuantity = false
  private isLoading = true
  private isShowMap = true

  private isMapLoaded = false
  private YandexMap: Map | null = null
  private ymapsScriptLoaded = false
  private ObjectManager: ObjectManager | null = null

  @Watch('items')
  private itemsHandler(items: IProductAvailabilityStoresItem[]) {
    if (items && items.length > 0) {
      this.ymapsReady()
    }
  }

  @Watch('isShowMap')
  private isShowMapHandler(val: boolean) {
    if (val && this.$device.isMobileOrTablet) {
      const wrapper = this.$refs.wrapper as HTMLElement
      ;(VueScrollTo as any).scrollTo(wrapper, {
        offset: -64,
        lazy: false,
      })
    }
  }

  @Watch('ymapsScriptLoaded')
  private onYmapsScriptLoadedHandler(val: boolean) {
    if (val && this.items.length > 0) {
      this.ymapsReady()
    }
  }

  private mounted() {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src =
      'https://api-maps.yandex.ru/2.1/?apikey=' +
      this.getApiKeyYandexMap +
      '&lang=ru_RU&onload=pageProductYmapsInit'

    document.getElementsByTagName('head')[0].appendChild(script)
    window.pageProductYmapsInit = this.pageProductYmapsInit
    window.pageProductOnClickPhone = this.pageProductOnClickPhone
  }

  private async created() {
    const response = await this.$axios.$get(
      filterUrl(PRODUCTS_API + '/' + this.productId + '/availability-stores')
    )
    this.title = response.title
    this.items = response.items
    this.isShowQuantity = response.isShowQuantity || false
    this.isLoading = false
    if (this.items.length === 0) {
      this.$emit('hide')
    }
  }

  private filterLabel(quantity: number): { text: string; color: string } {
    let quantityText = ''
    if (quantity) {
      quantityText = 'В наличии'
      if (this.isShowQuantity) {
        quantityText = quantityText + ': ' + quantity + ' ' + this.unit
      }
    } else {
      quantityText = 'Отсутствует'
    }

    return {
      text: quantityText,
      color: quantity ? 'success' : 'gray',
    }
  }

  private pageProductYmapsInit() {
    this.ymapsScriptLoaded = true
  }

  private ymapsReady() {
    if (this.ymapsScriptLoaded) {
      ymaps.ready(async () => {
        if (this.YandexMap) {
          this.ymapsDestroy()
        }
        this.YandexMap = new ymaps.Map('pageProductAvailabilityStoresMap', {
          controls: ['zoomControl', 'geolocationControl'],
          center: [55.76, 37.64],
          zoom: 7,
        })
        this.isMapLoaded = true

        await this.ymapsGeoObjectsInsert()
      })
    }
  }

  private ymapsDestroy() {
    if (this.YandexMap) {
      this.YandexMap.destroy()
      this.YandexMap = null
    }
    if (this.$refs.pageProductAvailabilityStoresMap) {
      ;(this.$refs.pageProductAvailabilityStoresMap as HTMLElement).innerHTML =
        ''
    }
  }

  private async ymapsGeoObjectsInsert() {
    if (this.YandexMap) {
      this.YandexMap.geoObjects.removeAll()
      this.ObjectManager = new ymaps.ObjectManager({
        clusterize: true,
      })

      const geoObjects: Placemark[] = []
      this.items.forEach((address) => {
        const temp = this.ymapsPlaceMarkInsert(address)
        if (temp) {
          geoObjects.push(temp)
        }
      })
      if (this.ObjectManager) {
        this.ObjectManager.add(JSON.stringify(geoObjects))
        this.YandexMap.geoObjects.add(this.ObjectManager) // eslint-disable-line
        const bounds: number[][] | null = this.YandexMap.geoObjects.getBounds()

        if (bounds !== null) {
          await this.YandexMap.setBounds(bounds, {
            checkZoomRange: true,
            zoomMargin: [64, 128],
          })

          if (this.YandexMap.getZoom() > 16) {
            await this.YandexMap.setZoom(16)
          }
        }
      }
    }
  }

  private pageProductOnClickPhone(el: HTMLElement) {
    const shadow = el.querySelector('.shadow')
    if (shadow && !shadow.classList.contains('hidden')) {
      shadow.classList.add('hidden')
    }
    analyticsReachGoal('goal_click_phone_map')
  }

  private ymapsPlaceMarkInsert(
    address: IProductAvailabilityStoresItem
  ): any | undefined {
    if (this.YandexMap) {
      const label = this.filterLabel(address.quantity)
      let balloonContentBody = `<div class="baloon-body__address">${address.address}</div>
            <div class="baloon-body__time">${address.time}</div>`
      if (address.phone) {
        balloonContentBody += `<div onclick="window.pageProductOnClickPhone(this)" class="baloon-body__phone shadow"><a class="baloon-body__phone-link" href="${filterPhone(
          address.phone
        )}">${address.phone}</a><div class="shadow"></div></div>`
      }

      balloonContentBody += `<div class="baloon-body__label ${label.color}">${label.text}</div>`

      return {
        type: 'Feature',
        id: address.id,
        geometry: {
          type: 'Point',
          coordinates: [address.lon.toString(), address.lat.toString()],
        },
        properties: {
          balloonContentHeader: `<a href="${address.url}" class="baloon-header">${address.title}</a>`,
          balloonContentBody,
        },
      }
    }
  }

  private zoomPlacemark(item: IProductAvailabilityStoresItem) {
    if (this.$device.isMobileOrTablet) {
      this.isShowMap = true
    }
    this.YandexMap?.panTo([item.lon, item.lat], { delay: 1000 }).then(() => {
      this.YandexMap?.setZoom(15, { duration: 1000 })
      this.ObjectManager?.objects.balloon.open(item.id.toString())
    })
  }

  private onClickPhone() {
    analyticsReachGoal('goal_click_phone_list')
  }

  private get classListWrapper() {
    return {
      [this.$style.listWrapper]: true,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.hidden]: this.$device.isMobileOrTablet && this.isShowMap,
    }
  }

  private get styleMap() {
    return {
      height: '50vh',
      width: '100%',
    }
  }
}
